import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

import { graphql } from "gatsby"

const post1url = "/blog/my-first-post"
const post1 = (
  <Link to={post1url}>2020-06-29 My first post</Link>
)

const post2url = "/blog/my-second-post"
const post2 = (
  <Link to={post2url}>2020-12-13 My second post</Link>
)

const post3url = "/blog/my-third-post"
const post3 = (
  <Link to={post3url}>2020-12-19 My third post</Link>
)

const IndexPage = ({data}) => {
  const [success, setSuccess] = useState(false);
  useEffect(() => {
    if (!success) {
      setSuccess(true);
    }
  }, [success]);
  /*
  const toppage = withPrefix('/')
  const ipfs = toppage !== '/'
  const links = ipfs ? (
    <div>
      <br />
      <h2>IPFSリンク集</h2>
      <a href='/ipns/ipfs.io/'>ipfs.io</a> <br />
      <a href='/ipns/js.ipfs.io/'>js.ipfs.io</a> <br />

      <a href='/ipns/awesome.ipfs.io/'>awesome.ipfs.io</a> <br />
      <a href='/ipns/peerpad.net/'>peerpad.net</a> <br />
    </div>
  ) : <div />
  */
  const posts = data.allMdx.nodes.map(({frontmatter}) => {
    const date = frontmatter.date
    const slug = frontmatter.slug
    const title = frontmatter.title
    const post = (
      <div key={slug}>
        <Link to={slug}>{date} {title}</Link>
        <br />
      </div>
    )
    return post
  })
  let addrchanged = (
    <>
      <a id="addrchanged" href="https://blog.sighash.info/">
        アドレスが変わりました。ここをクリックしてください。
      </a>
      <br />
      <br />
    </>
  );
  if (success) {
    addrchanged = null;
  }
  return (
    <Layout>
      <SEO title="Home" />
      {addrchanged}
      <h2>音楽関係</h2>
      <Link to='/audio'>Audio置き場</Link><br />
      <br />
      <h2>ブログ記事</h2>
      {posts}
      {post3}<br />
      {post2}<br />
      {post1}<br />
      <br />
      最終更新: {data.site.buildTime} <br />
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD HH:mm z")
    }
    allMdx(
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      nodes {
        frontmatter {
          date
          slug
          title
        }
      }
    }
  }
`
